
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ApiOperazioniDialog extends Serenity.EntityDialog<ApiOperazioniRow, any> {
        protected getFormKey() { return ApiOperazioniForm.formKey; }
        protected getIdProperty() { return ApiOperazioniRow.idProperty; }
        protected getLocalTextPrefix() { return ApiOperazioniRow.localTextPrefix; }
        protected getNameProperty() { return ApiOperazioniRow.nameProperty; }
        protected getService() { return ApiOperazioniService.baseUrl; }
        protected getDeletePermission() { return ApiOperazioniRow.deletePermission; }
        protected getInsertPermission() { return ApiOperazioniRow.insertPermission; }
        protected getUpdatePermission() { return ApiOperazioniRow.updatePermission; }

        protected form = new ApiOperazioniForm(this.idPrefix);

    }
}